import { createEffect, Actions, ofType } from '@ngrx/effects';
import { asyncScheduler, timer } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { SharedState } from '../../reducer';
import { LoadMonitor } from '../actions';
import { Injectable } from '@angular/core';
import {
  MonitorLivePollingActionTypes,
  MonitorLivePollingStart
} from './actions';
import {
  LiveUpdateService,
  THROTTLE_DELAY,
  getMessageDelay
} from '../../../services/live-update.service';
import { getDealFollows } from '../../reducer';
import { LiveUpdateMessage } from '../../../types/live-update.types';
import {
  switchMap,
  withLatestFrom,
  filter,
  throttleTime,
  delayWhen,
  map,
  takeUntil
} from 'rxjs/operators';

@Injectable()
export class MonitorLivePollingEffect {
  private monitorLiveUpdateStop$ = this.actions$.pipe(
    ofType(MonitorLivePollingActionTypes.StopMonitorPolling)
  );

  
  public readonly livePolling = createEffect(() => (scheduler = asyncScheduler) =>
    this.actions$.pipe(
      ofType<MonitorLivePollingStart>(
        MonitorLivePollingActionTypes.StartMonitorPolling
      ),
      switchMap(() => {
        return this.liveUpdateService.startPolling().pipe(
          withLatestFrom(this.store.pipe(select(getDealFollows))),
          filter(
            ([msg, monitorDeals]) =>
              (monitorDeals || []).indexOf(msg.DealId) > -1
          ),
          throttleTime(THROTTLE_DELAY, scheduler),
          delayWhen(([msg]) =>
            timer(getMessageDelay(msg as LiveUpdateMessage), scheduler)
          ),
          takeUntil(this.monitorLiveUpdateStop$),
          map(() => new LoadMonitor(false))
        );
      })
    ));

  constructor(
    private store: Store<SharedState>,
    private actions$: Actions,
    private liveUpdateService: LiveUpdateService
  ) {}
}
